import { QueryClientProvider, QueryClient } from "@tanstack/react-query"

const QueryProvider = ({ children }: React.PropsWithChildren<unknown>) => {
  const client = new QueryClient()
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
}

export default QueryProvider
